import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';

import { WindowService } from 'src/shared/providers/window.service';

@Component({
  templateUrl: './insurance.page.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InsurancePage {
  readonly windowService = inject(WindowService);
}
